// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_HOLIDAY, DELETE_HOLIDAY, EDIT_HOLIDAY, GET_HOLIDAY, HOLIDAY } from '../../../../common/constant'

export const actionHoliday = createAsyncThunk('appHoliday/actionHoliday', async (params, thunkAPI) => {
    return await post(HOLIDAY, params, thunkAPI)
})

export const actionAddHoliday = createAsyncThunk('appHoliday/actionAddHoliday', async (params, thunkAPI) => {
    return await put(ADD_HOLIDAY, params, thunkAPI)
})

export const actionGetHoliday = createAsyncThunk('appHoliday/actionGetHoliday', async (params, thunkAPI) => {
    return await post(GET_HOLIDAY, params, thunkAPI)
})

export const actionEditHoliday = createAsyncThunk('appHoliday/actionEditHoliday', async (params, thunkAPI) => {
    return await post(EDIT_HOLIDAY, params, thunkAPI)
})

export const actionDeleteHoliday = createAsyncThunk('appHoliday/actionDeleteHoliday', async (params, thunkAPI) => {
    return await post(DELETE_HOLIDAY, params, thunkAPI)
})

export const appHolidaySlice = createSlice({
    name: 'appHoliday',
    initialState: {
        //list
        loading: false,
        holiday: null,

        //add
        loadingAdd: false,
        addHoliday: null,

        //get
        loadingGet: false,
        getHoliday: null,

        //edit
        loadingEdit: false,
        editHoliday: null,

        //delete
        loadingDelete: false,
        deleteHoliday: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetHolidayResponse: (state) => {
            state.holiday = null
        },
        resetAddHolidayResponse: (state) => {
            state.addHoliday = null
        },
        resetGetHolidayResponse: (state) => {
            state.getHoliday = null
        },
        resetEditHolidayResponse: (state) => {
            state.editHoliday = null
        },
        resetDeleteHolidayResponse: (state) => {
            state.deleteHoliday = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionHoliday.pending, (state) => {
                state.loading = true
            })
            .addCase(actionHoliday.fulfilled, (state, action) => {
                state.loading = false
                state.holiday = action.payload
            })
            .addCase(actionHoliday.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddHoliday.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddHoliday.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addHoliday = action.payload
            })
            .addCase(actionAddHoliday.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetHoliday.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetHoliday.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getHoliday = action.payload
            })
            .addCase(actionGetHoliday.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditHoliday.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditHoliday.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editHoliday = action.payload
            })
            .addCase(actionEditHoliday.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteHoliday.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteHoliday.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteHoliday = action.payload
            })
            .addCase(actionDeleteHoliday.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetHolidayResponse, resetAddHolidayResponse, resetGetHolidayResponse, resetEditHolidayResponse, resetDeleteHolidayResponse } = appHolidaySlice.actions

export default appHolidaySlice.reducer